import React, { useState, useEffect } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { MenuItem, FormControl, Input, Grid, Button } from '@material-ui/core';
import SelectCustom from 'src/components/demand/Demand/screens/CETicket/components/SelectCustom';
import ContainerWrapper from 'src/components/demand/Demand/screens/CETicket/components/ContainerWrapper';
import Container from 'src/components/demand/Demand/screens/CETicket/components/Container';
import Name from 'src/components/demand/Demand/screens/CETicket/components/Name';
import Required from 'src/components/demand/Demand/screens/CETicket/components/Required';

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      root: {
        fontSize: '14px',
        color: '#228B22',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    MuiListItem: {
      root: {
        paddingBottom: '5px',
        paddingTop: '5px',
      },
    },
  },
});

const theme2 = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      root: {
        fontSize: '14px',
        color: '#62727b',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    MuiListItem: {
      root: {
        paddingBottom: '5px',
        paddingTop: '5px',
      },
    },
  },
});
function DropDownComponent(props) {
  const { element, onChange, index} = props;
  const [itemsSelected, setItemsSelected] = useState([]);
  const onDropChange = (event, element) => {
    setItemsSelected(itemsSelected => itemsSelected.concat(event.target.value));
    itemsSelected ? console.log(itemsSelected) : console.log("Nema jos podataka");
    onChange(event, element);
  };

  useEffect(()=>{
      console.log(itemsSelected)
  })
  return (
    <React.Fragment>
      <ContainerWrapper>
        <Container>
          <Name>
            <b>{element.name}:</b>
            {element.isMandatory && <Required>*</Required>}
          </Name>
          <MuiThemeProvider theme={theme2}>
            <SelectCustom
              disableUnderline={true}
              value={itemsSelected[index]}
              defaultValue={'99999'}
              onChange={event => onDropChange(event, element)}
              input={<Input name={element.id.toString()} />}
              variant="outlined"
              defaultValue="Not set"
            >
              {element.children.length > 0 &&
                element.children.map((item, index) => {
                  return (
                    <MenuItem
                      key={`${item.id}-${element.id}-${element.id}`}
                      value={item.id}
                    >
                      {!item.icon ||
                      item.name === 'Not set' ||
                      item.name === 'Custom' ? (
                        item.name
                      ) : (
                        <span>{item.name}</span>
                      )}
                    </MenuItem>
                  );
                })}
            </SelectCustom>
          </MuiThemeProvider>
        </Container>
      </ContainerWrapper>
    </React.Fragment>
  );
}

export default DropDownComponent;
